import { FC } from 'react';
import { IconProps } from '../types';

export const ChipBingoIcon: FC<IconProps> = ({ width = 18, height = 18, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
        fill="url(#paint0_linear_6015_66106)"
      />
      <path
        d="M7.64995 4.552H10.782V5.584H8.87395V8.152H10.602V9.148H8.87395V12.988H7.64995V4.552Z"
        fill="#4D4119"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6015_66106"
          x1="9.02951"
          y1="0"
          x2="9.02951"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF3D1" />
          <stop offset="0.19" stopColor="#D9B446" />
          <stop offset="0.335" stopColor="#DDBE63" />
          <stop offset="0.48" stopColor="#E1C266" />
          <stop offset="0.63" stopColor="#FFEEB5" />
          <stop offset="0.785" stopColor="#F1D277" />
          <stop offset="0.89" stopColor="#DCBB5B" />
          <stop offset="1" stopColor="#FFF2CA" />
        </linearGradient>
      </defs>
    </svg>
  );
};
